import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Nav from "../components/app/Nav";
import Footer from "../components/app/Footer";
import FloatingButton from "../components/app/FloatingButton";
import OurServicesCard from "../components/app/OurServicesCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTruckPickup,
  faBoxOpen,
  faRotateLeft,
  faFileImport,
  faCheckCircle,
  faShieldAlt,
  faClock,
  faGlobeAmericas,
} from "@fortawesome/free-solid-svg-icons";
import BoxIMG from "../assets/images/BoxNew.jpg";
import styles from "../styles/app/ServicesPage.module.css";
// OurServicesSection.css se carga globalmente al importar el componente OurServicesCard
import "../styles/app/OurServicesSection.css";

const servicesCards = [
  {
    id: "recogida-pickup",
    icon: faTruckPickup,
    title: "Recogida de Pickup",
    desc: "Gestionamos la recolección de tus paquetes directamente en tu puerta o proveedor para tu mayor comodidad.",
    color: "var(--elPaket-primary-color)",
    borderColor: "var(--elPaket-primary-color)",
  },
  {
    id: "recogida-dropoff",
    icon: faBoxOpen,
    title: "Recogida de DropOff",
    desc: "Deja tu paquete en la oficina de UPS más cercana para que sea entregado a la empresa de envío que hayas seleccionado.",
    color: "var(--elPaket-primary-color)",
    borderColor: "var(--elPaket-primary-color)",
  },
  {
    id: "envio-documentos",
    icon: faFileImport,
    title: "Envío de Documentos",
    desc: "Soluciones de mensajería y transporte para documentos, paquetes y mercancías, con procesos seguros y atención oportuna.",
    color: "var(--elPaket-primary-color)",
    borderColor: "var(--elPaket-primary-color)",
  },
];

const highlights = [
  {
    icon: faCheckCircle,
    title: "Cobertura Total",
    desc: "Más de 300 ciudades en Venezuela, República Dominicana, Costa Rica, Guatemala y Perú.",
    color: "var(--elPaket-primary-color)",
  },
  {
    icon: faShieldAlt,
    title: "Protección para tu envío",
    desc: "Tu envío cuenta con un seguro en caso de pérdida o daño, para mayor tranquilidad durante el transporte.",
    color: "var(--elPaket-primary-color)",
  },
  {
    icon: faClock,
    title: "Entrega Rápida",
    desc: "Envíos aéreos en 7–15 días hábiles. Marítimos en 4–6 semanas.",
    color: "var(--elPaket-primary-color)",
  },
  {
    icon: faGlobeAmericas,
    title: "Rastreo en Tiempo Real",
    desc: "Monitorea tu paquete paso a paso desde USA hasta la puerta del destinatario.",
    color: "var(--elPaket-primary-color)",
  },
];

const ServicesPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Nuestros Servicios de Envíos | elPaket</title>
        <meta
          name="description"
          content="Conoce los servicios logísticos de elPaket: Recogida a domicilio (Pick Up), entrega en tiendas UPS (Drop Off), envíos aéreos y marítimos a Venezuela, República Dominicana, Costa Rica, Guatemala y Perú."
        />
        <link
          rel="canonical"
          href="https://elpaket.com/servicios"
        />
      </Helmet>

      <Nav />

      <main className={styles.main}>
        {/* Hero */}
        <div className={styles.hero}>
          <p className={styles.headerBrand}>elPaket</p>
          <h1>Nuestros Servicios</h1>
          <p className={styles.subtitle}>
            Soluciones logísticas integrales diseñadas para conectar tu mundo
            con Latinoamérica.
          </p>
        </div>

        {/* Cards + imagen — reutiliza clases globales de OurServicesSection.css */}
        <section className={`${styles.servicesSection} our-services-section`}>
          <div className="our-services-container">
            <div className="our-services-header">
              <h2>Servicios que nos hacen únicos</h2>
              <p>
                Desde la recolección hasta la entrega, cubrimos cada paso de tu
                envío con profesionalismo y tecnología de punta.
              </p>
            </div>

            <div className={styles.servicesLayoutHorizontal}>
              <div className={styles.servicesCardsGridHorizontal}>
                {servicesCards.map((card, i) => (
                  <OurServicesCard {...card} key={i} />
                ))}
              </div>
              <div className="our-services-image">
                <img
                  src={BoxIMG}
                  alt="Servicio de entrega elPaket"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Highlights */}
        <section className={styles.highlights}>
          <div className={styles.highlightsInner}>
            <div className={styles.highlightsHeader}>
              <h2>¿Por qué elegirnos?</h2>
              <p>
                Combinamos tecnología, cobertura y atención personalizada para
                ofrecerte la mejor experiencia de envío.
              </p>
            </div>
            <div className={styles.highlightsGrid}>
              {highlights.map((h, i) => (
                <div className={styles.highlightCard} key={i}>
                  <div
                    className={styles.highlightIcon}
                    style={{ color: h.color }}
                  >
                    <FontAwesomeIcon icon={h.icon} />
                  </div>
                  <h3>{h.title}</h3>
                  <p>{h.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className={styles.ctaWrapper}>
          <div className={styles.cta}>
            <h2>¿Listo para enviar?</h2>
            <p>
              Regístrate gratis y comienza a enviar tus paquetes desde la
              comodidad de tu casa u oficina. Gestiona tus envíos de forma
              fácil, rápida y segura.
            </p>
            <div className={styles.ctaButtons}>
              <a href="/register" className={styles.ctaPrimary}>
                Crear cuenta gratis
              </a>
              <a href="/calculator" className={styles.ctaSecondary}>
                Calcular tarifa
              </a>
            </div>
          </div>
        </section>
      </main>

      {/*
      <FloatingButton />
      */}
      <Footer />
    </>
  );
};

export default ServicesPage;
